import React from "react";

export const StoreItemSkeleton = () => {
  return (
    <div className="relative overflow-hidden bg-r3dark/20 border border-r3lig/30 rounded-xl">
      <div className="absolute inset-0 -translate-x-full animate-shimmer bg-gradient-to-r from-transparent via-white/10 to-transparent" />

      {/* Image skeleton */}
      <div className="aspect-[1166/656] bg-slate-700/50" />

      {/* Content skeleton */}
      <div className="p-4 space-y-3">
        {/* Title skeleton */}
        <div className="h-6 bg-slate-700/50 rounded w-3/4 mx-auto" />

        {/* Price skeleton */}
        <div className="flex justify-center items-center gap-4">
          <div className="h-8 bg-slate-700/50 rounded w-24" />
          <div className="h-4 bg-slate-700/50 rounded w-8" />
          <div className="h-8 bg-slate-700/50 rounded w-24" />
        </div>

        {/* Button skeleton */}
        <div className="h-12 bg-slate-700/50 rounded-lg w-full" />
      </div>
    </div>
  );
};